export const TRANSACTION_TYPE = {
  CREDIT: "CREDIT",
  DEBIT: "DEBIT",
};

export const WALLET_OBJECT = "wallet";
